import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { MACHINES } from "@/data/site";
import { FadeUp } from "@/components/FadeUp";

const categories = Object.keys(MACHINES);

export default function MachineCapacity() {
  return (
    <div data-testid="machine-capacity-page" className="section-y">
      <div className="container-x">
        <FadeUp>
          <p className="eyebrow">Workshop Inventory · 2026</p>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-primary mt-4 leading-[0.95] max-w-4xl">
            Machine <span className="italic text-secondary">Capacity</span> & Capability.
          </h1>
          <p className="mt-8 max-w-2xl text-lg text-muted-foreground">
            A current spec sheet of our CNC, conventional, fabrication and inspection equipment.
            All figures are workshop-verified.
          </p>
        </FadeUp>

        <div className="mt-16">
          <Tabs defaultValue={categories[0]} data-testid="machine-category-tabs">
            <TabsList className="flex flex-wrap gap-2 bg-transparent justify-start h-auto p-0 mb-10">
              {categories.map((c) => (
                <TabsTrigger
                  key={c}
                  value={c}
                  data-testid={`tab-${c.replace(/\s+/g, "-").toLowerCase()}`}
                  className="px-4 py-2 text-xs uppercase tracking-[0.18em] rounded-none border border-border bg-white text-muted-foreground data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:border-primary transition-colors"
                >
                  {c}
                </TabsTrigger>
              ))}
            </TabsList>

            {categories.map((c) => (
              <TabsContent key={c} value={c} className="mt-0">
                <div className="bg-white border border-border" data-testid="machine-specs-table">
                  <Table>
                    <TableHeader>
                      <TableRow className="border-border">
                        <TableHead className="font-serif text-primary text-base">Machine</TableHead>
                        <TableHead className="font-serif text-primary text-base">Model</TableHead>
                        <TableHead className="font-serif text-primary text-base">Specifications</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {MACHINES[c].map((m, idx) => (
                        <TableRow key={`${c}-${idx}`} className="border-border">
                          <TableCell className="font-medium text-primary">{m.name}</TableCell>
                          <TableCell className="text-muted-foreground">{m.model}</TableCell>
                          <TableCell className="text-muted-foreground">{m.specs}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              </TabsContent>
            ))}
          </Tabs>
        </div>
      </div>
    </div>
  );
}
